const initialValues = {
  email: '',
  password: '',
};

export default initialValues;
